const theme = {
    colors: {
        primary: "#ff7d6b",
        text: "#6C6B6B",
        heading: "#0f034a",
        border: "#E0E0E0",
        secondary: "#4054b2",
        background: "#fff",
        hover: "#3f41e2",
        shark: "#929496",
        silver: "#ababab",
        nevada: "#63696a",
        white: "#ffffff",
        black: "#000000",
        success: "#61ce70",
        info: "#17a2b8",
        warning: "#ffc107",
        danger: "#dc3545",
        light: "#f8f9fa",
        boulder: "#7a7a7a",
        shaft: "#333333",
        orange: "#ff6600",
        red: "#FF0000",
        alabaster: "#fafafa",
        mystic: "#e1e8ed",
        facebook: "#3b5998",
    },
    fontSize: {
        body: "15px",
        h1: ["28px", "30px", "44px", "50px"],
        h2: ["26px", "30px", "32px", "38px"],
        h3: ["20px", "20px", "22px", "24px"],
        h4: ["18px", "18px", "18px", "20px"],
        h5: ["16px", "18px"],
        h6: ["16px", "16px"],
    },
    fonts: {
        body: `Gordita`,
        heading: `Gordita`,
    },
    fontWeights: {
        body: 500,
        heading: 600,
    },
    lineHeights: {
        body: 1.7,
        heading: 1.35,
    },
    radii: {
        default: "4px",
        sm: "3px",
        md: "6px",
        lg: "8px",
        round: "50%",
        pill: "500px",
    },
    shadows: {
        default: "0 0 12px 3px rgba(0, 0, 0, 0.06)",
        sm: "0px -1px 1px 0px rgba(0,0,0, .2)",
        lg: "0 1rem 3rem rgba(0, 0, 0, .175)",
    },
    breakpoints: ["576px", "768px", "992px", "1200px", "1400px"],
    transition: "all 0.4s ease 0s",
    text: {
        caps: {
            textTransform: "uppercase",
        },
        small: {
            fontSize: "14px",
            fontWeight: 600,
        },
        body: {
            fontFamily: "body",
            lineHeight: "body",
            fontWeight: "body",
            color: "text",
            fontSize: "body",
        },
    },
};

export default theme;
